import type { TaskType } from '@api';
import type { TaskFormSchemaType } from '../../hooks';

export const getTaskFormDefaultValues = (
  task: TaskType
): TaskFormSchemaType => ({
  title: task.title,
  description: task.description,
  context: task.context ?? '',
  priority: task.priority,
  userIds: task.audience
    .filter((entry) => entry.type === 'PERSON')
    .map((entry) => entry.id),
  teamIds: task.audience
    .filter((entry) => entry.type === 'TEAM')
    .map((entry) => entry.id),
});
